import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
import { defineComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, renderSlot } from 'vue';
import Abstract from '../abstract';

/**
 * 创建容器元素
 * @param targetId
 * @param themeClassName
 */
function createPopupContainer(targetId, className) {
  var popupContainer = document.getElementById(targetId);
  if (!popupContainer) {
    popupContainer = document.createElement('div');
    popupContainer.id = targetId;
    popupContainer.classList.add(className);
    popupContainer.style.position = 'absolute';
    popupContainer.style.top = '0px';
    popupContainer.style.left = '0px';
    popupContainer.style.width = '100%';
    document.body.appendChild(popupContainer);
  }
}
var _sfc_main = defineComponent({
  name: 'StepinLayout',
  extends: Abstract,
  components: {},
  props: {
    mode: {
      type: String,
      default: 'side'
    },
    collapsed: Boolean
  },
  data: function data() {
    return {
      className: 'layout'
    };
  },
  mounted: function mounted() {
    createPopupContainer('header-popup-container', 'stepin-header-theme');
    createPopupContainer('side-popup-container', 'stepin-side-theme');
  },
  computed: {
    navClass: function navClass() {
      var mode = this.mode;
      switch (mode) {
        case 'head':
          return 'head-nav';
        case 'mix':
          return 'mix-nav';
        default:
          return 'side-nav';
      }
    }
  }
});
var _export_sfc = function _export_sfc(sfc, props) {
  var target = sfc.__vccOpts || sfc;
  var _iterator = _createForOfIteratorHelper(props),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        val = _step$value[1];
      target[key] = val;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return target;
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass([_ctx.prefixCls, _ctx.navClass, {
      collapsed: _ctx.collapsed
    }])
  }, [createElementVNode("div", {
    class: normalizeClass("".concat(_ctx.prefixCls, "-header stepin-header-theme"))
  }, [renderSlot(_ctx.$slots, "header")], 2
  /* CLASS */), createElementVNode("div", {
    class: normalizeClass("".concat(_ctx.prefixCls, "-side stepin-side-theme"))
  }, [renderSlot(_ctx.$slots, "side")], 2
  /* CLASS */), createElementVNode("div", {
    class: normalizeClass("".concat(_ctx.prefixCls, "-content"))
  }, [renderSlot(_ctx.$slots, "default")], 2
  /* CLASS */)], 2
  /* CLASS */);
}

var StepinLayout = /* @__PURE__ */_export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/chenghongxing/VsCodeProjects/stepin/components/stepin-layout/StepinLayout.js"]]);
export { StepinLayout as default };